import PropTypes from 'prop-types'
import React from 'react'
import styles from './_map.css'

const propTypes = {
  routeId: PropTypes.string.isRequired,
}

export function Map (props) {
  const { routeId } = props
  return (
    <section className={styles.container}>
      <img className={styles.map} src={`/routes/print_image/${routeId}`} />
    </section>
  )
}

Map.propTypes = propTypes

export default Map



// WEBPACK FOOTER //
// ./src/components/routes/print/Map.jsx